import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=d27b93c8&scoped=true&"
import script from "./Employment.vue?vue&type=script&lang=js&"
export * from "./Employment.vue?vue&type=script&lang=js&"
import style0 from "./Employment.vue?vue&type=style&index=0&id=d27b93c8&lang=scss&scoped=true&"
import style1 from "./Employment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27b93c8",
  null
  
)

export default component.exports